module.exports = {"370683001":"文昌路街道","370683002":"永安路街道","370683003":"三山岛街道","370683004":"城港路街道","370683005":"文峰路街道","370683006":"金仓街道","370683101":"沙河镇","370683102":"朱桥镇","370683103":"郭家店镇","370683104":"金城镇","370683105":"平里店镇","370683106":"驿道镇","370683107":"程郭镇","370683108":"虎头崖镇","370683109":"柞村镇","370683110":"夏邱镇","370683111":"土山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370683.json
// module id = 1525
// module chunks = 0